import calendarsService from './calendarsService'

export default calendarsService



// WEBPACK FOOTER //
// ../src/services/calendarsService/index.js